import { DatePipe } from "@angular/common";
import { ApiMethod } from "../apimethods/api-method";

declare var $;
export class GlobalConstants {
  public static siteTitle: string = "SesameWms";

  public static size = {
    width: window.innerWidth || document.body.clientWidth,
    height: window.innerHeight || document.body.clientHeight
  }
  public static isNullBoolean(element) {
    return element == null ? 'No' : (element == true ? 'Yes' : 'No');
  }
  public static isNullCheck(element) {
    return element == null ? "" : element;
  }
  public static isNaNCheck(element) {
    return element == null ? "0" : element;
  }
  public static GetTableRowToList(zTableID, aTitle, withHtml = false) {
    var getResultList = [];

    $("table#" + zTableID + " tr").each(function () {
      var arrayOfThisRow = [];
      if ($(this).className != 'tdHeading') {
        var tableData = $(this).find('td').not(".tdHeading");

        if (tableData.length > 0) {
          tableData.each(function (index) {
            try {
              var indexL = "col" + index;
              if ($(this).find('select').length > 0) {
                arrayOfThisRow.push($(this).find('select').val());
              }
              else if ($(this).find('input[type="file"]').length > 0) {
                arrayOfThisRow.push($(this).find('input').val());
              }
              else if ($(this).find('.rating').length > 0) {
                arrayOfThisRow.push($(this).find('.rating').attr('value'));
              }
              else if ($(this).text().trim() == '' && $(this).find('input').length > 0) {
                if ($(this).find('input')[0].value == 'on') {
                  arrayOfThisRow.push($(this).find('input')[0].checked);
                }
                else {
                  var zActivityNameL = $(this).find('input')[0].value.toString().replace(",", "");
                  arrayOfThisRow.push(zActivityNameL);
                }
              }
              else {
                if ($(this).closest('table')[0].className != 'emoji-table') {
                  if (aTitle != null) {
                    arrayOfThisRow.push($(this).text().trim().replace(/,/g, '|'));
                  }
                  else if (withHtml) {
                    arrayOfThisRow.push($(this).html().replace(/,/g, '_comma_'));
                  }
                  else {
                    arrayOfThisRow.push($(this).text());
                  }
                }
              }
            } catch (e) {
            }

          });
          if (arrayOfThisRow.length > 0) {
            getResultList.push(arrayOfThisRow);
          }
        }
      }
    });
    return getResultList;
  }

  public static CheckMetadataView(actionName, checkUpdate = false) {
    try {
      //Check Edit Action available for Metadata editing
      var menuList = JSON.parse(localStorage.aMenuList);
      var chkMetaDataAction = menuList.filter(a => a.MenuName == actionName);
      if (chkMetaDataAction.length == 0) {
        return false;
      }
      else {
        if (checkUpdate == true) {
          if (chkMetaDataAction[0].Action.indexOf('Update') == -1) {
            return false;
          }
          else {
            return true;
          }
        }
        else {
          if (chkMetaDataAction[0].Action.indexOf('View') == -1) {
            return false;
          }
        }
        return true;
      }
    } catch (e) {
      return false;
    }
  }
  public static monthList = [
    { name: 'January', value: '01' },
    { name: 'February', value: '02' },
    { name: 'March', value: '03' },
    { name: 'April', value: '04' },
    { name: 'May', value: '05' },
    { name: 'June', value: '06' },
    { name: 'July', value: '07' },
    { name: 'August', value: '08' },
    { name: 'September', value: '09' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'December', value: '12' },
  ];

  public static month_names = ["Jan", "Feb", "Mar",
    "Apr", "May", "Jun",
    "Jul", "Aug", "Sep",
    "Oct", "Nov", "Dec"];

  public static monthFullNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];

  public static FormatDate(dateL, addDate = 0, withTime = false) {
    try {

      let showDatetime: boolean = GlobalConstants.CheckMetadataView('Show Datetime Activity List');

      if (showDatetime) {
        return this.FromateDateWithTime(dateL);
      }

      if (dateL == null || dateL == '')
        return '';
      var date = new Date(dateL);
      if (typeof addDate != "undefined") {
        date.setDate(date.getDate() + addDate);
      }
      var day = date.getDate();
      var dayString = day > 9 ? day : '0' + day;
      var dtT = dayString + ' ' + this.month_names[date.getMonth()] + ' ' + date.getFullYear(); //month_names[date.getMonth()]

      let hrs = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
      let min = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
      let sec = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
      dtT = dtT; //+ ' ' + hrs + ':' + min + ':' + sec;

      return dtT;
    } catch (e) {
      return '';
    }
  }

  public static SetValue_FormatDate(dateL) {
    try {
      if (dateL == null || dateL == '')
        return dateL;
      var date = new Date(dateL);
      var day = date.getDate();
      var dayString = day > 9 ? day : '0' + day;
      var month = (date.getMonth() + 1);
      var monthString = month > 9 ? month : '0' + month;
      var dtT = date.getFullYear() + '-' + monthString + '-' + dayString; //month_names[date.getMonth()] 
      return dtT;
    } catch (e) {
      return '';
    }
  }

  public static FormatDate_IE(datep) {
    try {
      var dateL = datep.split(' ');
      var zmonthL = this.month_names.indexOf(dateL[1].toString()) + 1;
      var monthString = zmonthL > 9 ? zmonthL : '0' + zmonthL;
      var dtT = dateL[2].toString() + '-' + monthString + '-' + dateL[0].toString();
      return dtT;
    } catch (e) {
      return '';
    }
  }

  public static FromateDateName(dateTime) {
    try {
      if (dateTime == null || dateTime == '')
        return '';

      var date = new Date(dateTime);
      var hrs = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
      var mints = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
      var secs = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
      var formatted = ("0" + date.getDate()).slice(-2) + " " +
        this.month_names[date.getMonth()] + " " + // ("0" + (date.getMonth() + 1)).slice(-2)
        date.getFullYear();
      return formatted;
    } catch (e) {
      return '';
    }
  }

  public static FromateDateWithTime(dateTime) {
    try {
      if (dateTime == null || dateTime == '')
        return '';

      var date = new Date(dateTime);
      var hrs = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
      var mints = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
      var secs = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
      var formatted = ("0" + date.getDate()).slice(-2) + " " +
        this.month_names[date.getMonth()] + " " + // ("0" + (date.getMonth() + 1)).slice(-2)
        date.getFullYear() + " " + hrs + ":" + mints + ':' + secs;
      return formatted;
    } catch (e) {
      return '';
    }
  }
  public static FormatDateTime(DateTime)    //Jun 15, 2019, 10:54:25 PM   
  {
    try {
      if (DateTime == null) {
        return '';
      }
      let pipe = new DatePipe('en-US');
      let myShortFormat = pipe.transform(DateTime, 'medium');
      return myShortFormat;
    } catch (e) {
      return '';
    }

  }
  public static CurrentDateWithTime() {
    var date = new Date();
    var hrs = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
    var mints = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
    var sec = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
    var formatted = ("0" + date.getDate()).slice(-2) + "_" +
      this.month_names[date.getMonth()] + "_" +
      date.getFullYear() + "_" + hrs + "_" + mints + "_" + sec;
    return formatted;
  }

  public static addDays(date, days) {
    const copy = new Date(Number(date));
    copy.setDate(date.getDate() + days);
    return copy;
  }

  public static calcWorkingDays(fromDate, days) {
    let count = 0;
    while (count < days) {
      fromDate.setDate(fromDate.getDate() + 1);
      if (fromDate.getDay() != 0 && fromDate.getDay() != 6) // Skip weekends
        count++;
    }
    return fromDate;
  }

  public static calcWorkingDays_before(fromDate, days) {
    var count = 0;
    while (count < days) {
      fromDate.setDate(fromDate.getDate() - 1);
      count++;
    }
    return fromDate;
  }

  public static GetTitleFormat(textStr) {
    if (typeof textStr !== 'string') return textStr; // Ensure the input is a string
    try {
      return textStr
        .replace(/([A-Z])/g, ' $1') // Add a space before each capital letter
        .trim()                     // Remove any leading spaces
        .toLowerCase()              // Convert the string to lowercase
        .replace(/\b[a-z]/g, letter => letter.toUpperCase()); // Title case each word
    } catch (e) {
      return textStr;
    }
  }

  public static resetStorage() {
    //Clear localStorage 
    //let loginId = localStorage.getItem('aLoginID'); let aPubID = localStorage.getItem('aPubID'); let UserThemes = localStorage.getItem('UserThemes');
    //localStorage.clear();
    //localStorage.setItem('aLoginID', loginId); localStorage.setItem('aPubID', aPubID); localStorage.setItem('UserThemes', UserThemes);
  }


  public static async reloadData() {
    if (localStorage.athemesList == null) {
      var userItem = {
        LoginID: localStorage.aLoginID
      };
      await ApiMethod.postMethod('api/reload', userItem).subscribe(
        resonse => {
          let aUserList = resonse.aitemList; let aMenuList = resonse.aMenuAccessList; let athemesList = resonse.athemesList;
          $("#LoadingImage").hide();
          localStorage.aPubID = aUserList[0].EPublisherID; localStorage.aLoginID = aUserList[0].EUserID; localStorage.aLoginName = aUserList[0].LoginName;
          localStorage.UserThemes = aUserList[0].Themes; localStorage.athemesList = JSON.stringify(athemesList); localStorage.aImgLogo = (aUserList[0].Image == null ? '../../../assets/Images/userLogo.jpg' : aUserList[0].Image);
          localStorage.aMenuList = JSON.stringify(aMenuList);

        }
      );
    }
  }

  public static distinctBy(key, array) {
    var keys = array.map(function (value) { return value[key]; });
    return array.filter(function (value, index) { return keys.indexOf(value[key]) === index; });
  }

  public static GetChartDataSeriesList(groupKey, groupName, dataValue, dataName, dataList, dataSeriesList, ypointCode = '') {

    var _dataList = [];

    $.each(dataList, function (index, val) {
      if (val[groupKey] == groupName) {
        _dataList.push({
          name: val[dataName], y: (val[dataValue] == 0 ? '' : val[dataValue])
        });
      }
    });

    if (_dataList.length > 0) {
      let _color = '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
      dataSeriesList.push({
        name: groupName,
        data: _dataList, color: _color,
        dataLabels: {
          enabled: true, color: '#000', format: ypointCode + ' {point.y}'
        }
      });
    }
    return dataSeriesList;
  }

}
